<template>
	<div
		v-editable="blok"
		class="flex max-w-sm flex-col items-center px-3 pt-8 text-center lg:pt-12"
	>
		<SbImage
			v-if="blok?.icon?.filename"
			:blok="blok.icon"
			class="mb-6 size-12"
			alt="Policy Benefits Image"
		/>

		<div
			v-if="headingMediumHtml"
			class="text-primary-600 pb-2 font-serif text-xl font-bold"
			v-html="headingMediumHtml"
		/>

		<div
			v-if="headingSmallHtml"
			class="text-secondary-500 text-md leading-7"
			v-html="headingSmallHtml"
		/>
	</div>
</template>

<script setup lang="ts">
import SbImage from '@/components/blocks/SbImage.vue'
import type { PolicyBenefitsCardStoryblok } from '@/sbTypes'
import { renderRichText } from '@storyblok/vue'
import { computed, type PropType } from 'vue'

const props = defineProps({
	blok: Object as PropType<PolicyBenefitsCardStoryblok>,
})

const headingMediumHtml = computed(
	() => renderRichText(props.blok?.headingMedium) ?? ''
)

const headingSmallHtml = computed(
	() => renderRichText(props.blok?.headingSmall) ?? ''
)
</script>
